import { jsxs as s, jsx as o } from "react/jsx-runtime";

import a from "../hooks/useGlobals.js";

import e from "../../../utils/classNames/index.js";

const r = ({className: r, ...t}) => {
    const {components: m} = a();
    return s("div", {
        ...t,
        className: e("gap-xs grid", r),
        children: [ o(m.MonthYear, {}), o(m.DaysTable, {}) ]
    });
};

export { r as default };
//# sourceMappingURL=DayView.js.map
